import React, { FC, useEffect } from 'react';
import {
  useTracking,
  usePersistedSessionState,
} from '@edreamsodigeo/frontend-core';
import { getSearchUrl } from '@components/AlternativeFlight/helpers';
import { usePersistedFlightSelection } from 'clientState/hooks/usePersistedFlightSelection/usePersistedFlightSelection';
import BaseWarningModal from './BaseWarningModal';

type BrokenFlowProps = {
  open: boolean;
  onClose: () => void;
};

const BrokenFlowModal: FC<BrokenFlowProps> = ({ open, onClose }) => {
  const { trackEvent } = useTracking();
  const [searchParameters] = usePersistedSessionState('searchParameters');
  const [flightSelectionData] = usePersistedFlightSelection();

  const onClick = () => {
    const searchUrl = getSearchUrl(searchParameters);
    window.location.assign(searchUrl);
    trackEvent({
      category: 'details_loading',
      action: 'request_errors_OF2',
      label: 'broken_flow_back-results',
    });
  };

  useEffect(() => {
    if (open) {
      trackEvent({
        category: 'details_loading',
        action: 'request_errors_OF2',
        label: `alternative-flights-modal-error-searchId-${flightSelectionData?.data?.searchId}-itineraryId-${flightSelectionData?.data?.fareItineraryKey}`,
      });
    }
  }, [open, trackEvent, flightSelectionData]);

  return (
    <BaseWarningModal
      open={open}
      onClose={onClose}
      onClick={onClick}
      title="error.brokenflow.title"
      description="error.brokenflow.description"
      button="error.brokenflow.button"
    />
  );
};

export default BrokenFlowModal;
